import { atom } from 'recoil';

export const leftBarState = atom<boolean>({
  key: 'leftbar',
  default: false,
});
